import React, { useState, useEffect, useCallback } from 'react';
import MenuPreview from './MenuPreview';

const WORKER_URL = 'https://rakeen-whatsapp-poc.thamer-21d.workers.dev';

const OPTION_TYPES = [
  { value: 'submenu', label: 'قائمة فرعية' },
  { value: 'reply', label: 'رد مباشر' },
  { value: 'handoff', label: 'تحويل لموظف' },
];

// ─── Collapsible Option Editor ───

function OptionEditor({ option, index, onUpdate, onRemove, onSave, saving }) {
  const [expanded, setExpanded] = useState(false);
  const [subExpanded, setSubExpanded] = useState({});

  const update = (field, value) => onUpdate(index, field, value);

  const updateSub = (subIndex, field, value) => {
    const submenu = [...(option.submenu || [])];
    submenu[subIndex] = { ...submenu[subIndex], [field]: value };
    onUpdate(index, 'submenu', submenu);
  };

  const addSub = () => {
    const submenu = [...(option.submenu || [])];
    const key = String(submenu.length + 1);
    submenu.push({ key, label: '', autoReply: '', type: 'reply', tag: '', detailsPrompt: '' });
    onUpdate(index, 'submenu', submenu);
  };

  const removeSub = (subIndex) => {
    let submenu = (option.submenu || []).filter((_, i) => i !== subIndex);
    submenu = submenu.map((o, i) => ({ ...o, key: String(i + 1) }));
    onUpdate(index, 'submenu', submenu);
  };

  const toggleSub = (subIndex) => {
    setSubExpanded((prev) => ({ ...prev, [subIndex]: !prev[subIndex] }));
  };

  const subCount = (option.submenu || []).length;
  const typeLabel = OPTION_TYPES.find((t) => t.value === option.type)?.label || option.type;

  return (
    <div className={`sd-menu-option ${expanded ? 'sd-menu-option-expanded' : ''}`}>
      {/* Collapsed Header */}
      <div className="sd-menu-option-bar" onClick={() => setExpanded(!expanded)}>
        <span className="sd-menu-option-num">{option.key}️⃣</span>
        <span className="sd-menu-option-label">{option.label || '(بدون اسم)'}</span>
        <span className="sd-menu-option-type-badge">{typeLabel}</span>
        {subCount > 0 && <span className="sd-menu-option-sub-count">{subCount} فرعي</span>}
        <span className="sd-menu-option-expand">{expanded ? '▲ طي' : '▼ توسيع'}</span>
        <button
          className="sd-menu-option-save-inline"
          onClick={(e) => { e.stopPropagation(); onSave(index); }}
          disabled={saving}
        >
          {saving ? '...' : '💾'}
        </button>
      </div>

      {/* Expanded Editor */}
      {expanded && (
        <div className="sd-menu-option-body">
          <div className="sd-menu-option-fields">
            <div className="sd-menu-field">
              <label>النص</label>
              <input type="text" value={option.label} onChange={(e) => update('label', e.target.value)} placeholder="طلب عرض سعر" />
            </div>
            <div className="sd-menu-field-row">
              <div className="sd-menu-field">
                <label>النوع</label>
                <select value={option.type} onChange={(e) => update('type', e.target.value)}>
                  {OPTION_TYPES.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
                </select>
              </div>
              <div className="sd-menu-field">
                <label>التصنيف</label>
                <input type="text" value={option.tag} onChange={(e) => update('tag', e.target.value)} placeholder="عرض سعر" />
              </div>
            </div>
            <div className="sd-menu-field">
              <label>{option.type === 'submenu' ? 'رسالة القائمة الفرعية' : 'الرد التلقائي'}</label>
              <textarea value={option.autoReply} onChange={(e) => update('autoReply', e.target.value)} rows={2} />
            </div>
          </div>

          {/* Submenu */}
          {option.type === 'submenu' && (
            <div className="sd-menu-submenu">
              <h5>الخيارات الفرعية ({subCount})</h5>
              {(option.submenu || []).map((sub, j) => (
                <div key={j} className="sd-menu-suboption">
                  <div className="sd-menu-suboption-bar" onClick={() => toggleSub(j)}>
                    <span>{option.key}.{sub.key}</span>
                    <span className="sd-menu-suboption-label">{sub.label || '(بدون اسم)'}</span>
                    <span className="sd-menu-option-expand">{subExpanded[j] ? '▲' : '▼'}</span>
                    <button className="sd-menu-option-remove" onClick={(e) => { e.stopPropagation(); removeSub(j); }}>حذف</button>
                  </div>
                  {subExpanded[j] && (
                    <div className="sd-menu-suboption-body">
                      <div className="sd-menu-field">
                        <label>النص</label>
                        <input type="text" value={sub.label} onChange={(e) => updateSub(j, 'label', e.target.value)} />
                      </div>
                      <div className="sd-menu-field">
                        <label>التصنيف</label>
                        <input type="text" value={sub.tag} onChange={(e) => updateSub(j, 'tag', e.target.value)} />
                      </div>
                      <div className="sd-menu-field">
                        <label>الرد أو طلب التفاصيل</label>
                        <textarea
                          value={sub.detailsPrompt || sub.autoReply || ''}
                          onChange={(e) => {
                            if (sub.detailsPrompt !== undefined && sub.detailsPrompt !== '') {
                              updateSub(j, 'detailsPrompt', e.target.value);
                            } else {
                              updateSub(j, 'autoReply', e.target.value);
                            }
                          }}
                          rows={2}
                        />
                      </div>
                    </div>
                  )}
                </div>
              ))}
              <button className="sd-menu-add-sub" onClick={addSub}>+ أضف خيار فرعي</button>
            </div>
          )}

          {/* Option Actions */}
          <div className="sd-menu-option-actions">
            <button
              className="sd-menu-option-save-btn"
              onClick={() => onSave(index)}
              disabled={saving}
            >
              {saving ? '...جاري الحفظ' : '💾 حفظ هذا الخيار'}
            </button>
            <button className="sd-menu-option-remove-btn" onClick={() => onRemove(index)}>🗑️ حذف</button>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Menu Config Page ───

function MenuConfigPage({ idToken, role }) {
  const [config, setConfig] = useState(null);
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [savingOption, setSavingOption] = useState(null);
  const [saveNotes, setSaveNotes] = useState('');
  const [showVersions, setShowVersions] = useState(false);
  const [showGeneralSettings, setShowGeneralSettings] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const fetchConfig = useCallback(async () => {
    try {
      const res = await fetch(`${WORKER_URL}/api/menu-config`, {
        headers: { 'Authorization': `Bearer ${idToken}` },
      });
      if (res.ok) {
        const data = await res.json();
        if (data.config) setConfig(data.config);
        if (data.versions) setVersions(data.versions);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  }, [idToken]);

  useEffect(() => { fetchConfig(); }, [fetchConfig]);

  const saveFullConfig = async (notes) => {
    if (!config) return;
    setSaving(true);
    try {
      const res = await fetch(`${WORKER_URL}/api/menu-config`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` },
        body: JSON.stringify({ config, notes: notes || saveNotes }),
      });
      if (res.ok) {
        const data = await res.json();
        setSaveNotes('');
        await fetchConfig();
        alert(`تم الحفظ — ${data.version}`);
      }
    } catch (err) {
      alert('خطأ في الحفظ');
    }
    setSaving(false);
  };

  const saveOption = async (index) => {
    setSavingOption(index);
    await saveFullConfig(`تحديث خيار ${config.options[index]?.label || index + 1}`);
    setSavingOption(null);
  };

  const rollback = async (version) => {
    if (!window.confirm(`تفعيل النسخة ${version}؟`)) return;
    try {
      await fetch(`${WORKER_URL}/api/menu-config/rollback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` },
        body: JSON.stringify({ version }),
      });
      await fetchConfig();
      alert(`تم تفعيل ${version}`);
    } catch (err) {
      alert('خطأ');
    }
  };

  const seedDefault = async () => {
    try {
      const res = await fetch(`${WORKER_URL}/api/menu-config/seed`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${idToken}` },
      });
      const data = await res.json();
      if (data.existing) alert('النسخة الافتراضية موجودة بالفعل');
      else { await fetchConfig(); alert('تم إنشاء النسخة الافتراضية v1'); }
    } catch (err) {
      alert('خطأ');
    }
  };

  const updateOption = (index, field, value) => {
    const updated = { ...config, options: [...config.options] };
    if (field === 'submenu') {
      updated.options[index] = { ...updated.options[index], submenu: value };
    } else {
      updated.options[index] = { ...updated.options[index], [field]: value };
    }
    setConfig(updated);
  };

  const addOption = () => {
    if (config.options.length >= 6) return;
    const key = String(config.options.length + 1);
    setConfig({
      ...config,
      options: [...config.options, { key, label: '', autoReply: '', type: 'reply', tag: '' }],
    });
  };

  const removeOption = (index) => {
    if (!window.confirm('حذف هذا الخيار؟')) return;
    let options = config.options.filter((_, i) => i !== index);
    options = options.map((o, i) => ({ ...o, key: String(i + 1) }));
    setConfig({ ...config, options });
  };

  if (loading) return <div className="sd-menu-loading">جاري التحميل...</div>;

  if (!config) {
    return (
      <div className="sd-menu-empty">
        <p>لا يوجد تكوين للقائمة بعد</p>
        <button className="sd-menu-seed-btn" onClick={seedDefault}>إنشاء القائمة الافتراضية (v1)</button>
      </div>
    );
  }

  return (
    <div className="sd-menu-config">
      {/* Top Actions */}
      <div className="sd-menu-header">
        <div className="sd-menu-header-actions">
          <button className="sd-menu-save-btn" onClick={() => saveFullConfig()} disabled={saving}>
            {saving ? '...جاري الحفظ' : '💾 حفظ الكل كنسخة جديدة'}
          </button>
          <button className="sd-menu-versions-btn" onClick={() => { setShowPreview(!showPreview); setShowVersions(false); }}>
            📱 {showPreview ? 'إخفاء المعاينة' : 'معاينة'}
          </button>
          <button className="sd-menu-versions-btn" onClick={() => { setShowVersions(!showVersions); setShowPreview(false); }}>
            📜 سجل النسخ ({versions.length})
          </button>
          {!versions.length && (
            <button className="sd-menu-seed-btn-sm" onClick={seedDefault}>تهيئة v1</button>
          )}
        </div>
      </div>

      {/* Version History */}
      {showVersions && (
        <div className="sd-menu-versions">
          <h4>📜 سجل النسخ</h4>
          {versions.length === 0 ? (
            <p className="sd-menu-versions-empty">لا توجد نسخ</p>
          ) : (
            <div className="sd-menu-versions-list">
              {[...versions].reverse().map((v) => (
                <div key={v.version} className={`sd-menu-version-row ${v.isDefault ? 'sd-version-default' : ''}`}>
                  <span className="sd-version-name">{v.version} {v.isDefault ? '(الافتراضية)' : ''}</span>
                  <span className="sd-version-date">{new Date(v.savedAt).toLocaleString('ar-SA')}</span>
                  <span className="sd-version-user">{v.savedBy}</span>
                  {v.notes && <span className="sd-version-notes">{v.notes}</span>}
                  <button className="sd-version-activate" onClick={() => rollback(v.version)}>تفعيل</button>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Interactive Preview */}
      {showPreview && <MenuPreview config={config} />}

      {/* General Settings — Collapsible */}
      <div className="sd-menu-option">
        <div className="sd-menu-option-bar" onClick={() => setShowGeneralSettings(!showGeneralSettings)}>
          <span className="sd-menu-option-num">⚙️</span>
          <span className="sd-menu-option-label">الإعدادات العامة</span>
          <span className="sd-menu-option-type-badge">{config.isActive ? 'مفعّلة' : 'معطّلة'}</span>
          <span className="sd-menu-option-expand">{showGeneralSettings ? '▲ طي' : '▼ توسيع'}</span>
        </div>
        {showGeneralSettings && (
          <div className="sd-menu-option-body">
            <div className="sd-menu-field">
              <label>القائمة</label>
              <label className="sd-menu-toggle">
                <input type="checkbox" checked={config.isActive} onChange={(e) => setConfig({ ...config, isActive: e.target.checked })} />
                <span>{config.isActive ? '✅ مفعّلة' : '⬜ معطّلة'}</span>
              </label>
            </div>
            <div className="sd-menu-field">
              <label>رسالة الترحيب</label>
              <textarea value={config.welcomeMessage} onChange={(e) => setConfig({ ...config, welcomeMessage: e.target.value })} rows={4} />
            </div>
            <div className="sd-menu-field">
              <label>رسالة الخطأ</label>
              <input type="text" value={config.fallbackMessage} onChange={(e) => setConfig({ ...config, fallbackMessage: e.target.value })} />
            </div>
            <div className="sd-menu-field">
              <label>إعادة تشغيل بعد (ساعات)</label>
              <input type="number" value={config.resetAfterHours} onChange={(e) => setConfig({ ...config, resetAfterHours: parseInt(e.target.value, 10) || 2 })} min={1} max={48} />
            </div>
          </div>
        )}
      </div>

      {/* Menu Options — Collapsible */}
      <div className="sd-menu-section-title">
        <h3>خيارات القائمة ({config.options.length}/6)</h3>
      </div>

      {config.options.map((option, i) => (
        <OptionEditor
          key={`${option.key}-${i}`}
          option={option}
          index={i}
          onUpdate={updateOption}
          onRemove={removeOption}
          onSave={saveOption}
          saving={savingOption === i}
        />
      ))}

      {config.options.length < 6 && (
        <button className="sd-menu-add-option" onClick={addOption}>+ أضف خيار</button>
      )}

      {/* Save All */}
      <div className="sd-menu-section">
        <div className="sd-menu-field">
          <label>ملاحظات الحفظ (اختياري)</label>
          <input type="text" value={saveNotes} onChange={(e) => setSaveNotes(e.target.value)} placeholder="مثال: أضفت قسم العوازل" />
        </div>
        <button className="sd-menu-save-btn sd-menu-save-bottom" onClick={() => saveFullConfig()} disabled={saving}>
          {saving ? '...جاري الحفظ' : '💾 حفظ الكل كنسخة جديدة'}
        </button>
      </div>
    </div>
  );
}

export default MenuConfigPage;
